import { ExecutorId } from './Generic/models/ExecutorId'
import { getNonEmptyArrayEnvVar } from './util/src/process'
import { NonEmptyArray } from './util/src/array'

export function getExecutorIds(): NonEmptyArray<ExecutorId> {
  return getNonEmptyArrayEnvVar('NEXT_PUBLIC_EXECUTOR_IDS', process.env.NEXT_PUBLIC_EXECUTOR_IDS)
}

export const supabaseCacheTasksPath = 'tasks.data.json'
